const AssetTagReducer = (state = {tag : null}, action) => {
    switch (action.type) {
        case "SetAssetTag":
            state = {
                tag : action.payload.tag
            }
            break;
        default:
            break;
    }
    return state
}

export {AssetTagReducer}


// WEBPACK FOOTER //
// ./src/App/store/items.js